// Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved.
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'app-with-annot-tooltip-card',
  standalone: true,
  template: `
    <div class="tooltip-surface">
      <pre class="tooltip-text">{{ text }}</pre>
    </div>
  `,
  styles: [`
  .tooltip-surface {
    background: #fff;
    color: #222;
    border: 1px solid #666;
    border-radius: 2px;
    box-shadow: none;
    padding: 4px 6px;
    max-width: none;
    max-height: none;
    overflow: visible;
    pointer-events: none;
  }
  .tooltip-text {
    margin: 0;
    white-space: pre;
    word-break: normal;
    font-size: 10px;
    line-height: 1.1;
    letter-spacing: 0;
  }
`]
  ,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WithAnnotTooltipCardComponent {
  @Input() text = '';
}